import template from './report_leave_per_department_people.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportLeavePerDepartmentEmployeeViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);
		let firstDay = moment().format('YYYY-MM-01');
		let lastDay = moment().format('YYYY-MM-') + moment().daysInMonth();

		this.date_start = ko.observable(new Date(firstDay).toJSON().slice(0, 10));
		this.date_end = ko.observable(new Date(lastDay).toJSON().slice(0, 10));
		this.refresh_button = ko.observable(false);

		this.total_leave_in_company = ko.observable(0);
		this.department_with_most_leave = ko.observable('None');
		this.department_leave_total = ko.observable(0);

		this.leave_types = ko.observableArray();
		this.selected_leave_type = ko.observable(0);
		this.selected_leave_types = ko.observableArray();

		this.end_date_timeout = null;
		this.start_date_timeout = null;

		this.date_start.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.start_date_timeout) 
				clearTimeout(this.start_date_timeout);

			// Set new timeout to wait for user to finish typing or selecting date
			this.start_date_timeout = setTimeout(() => {
				let sd = moment(newValue, 'YYYY-MM-DD', true);
				if (!sd.isValid()) return;

				// Update end date to last day of start date month
				let month_end = moment(sd).endOf('month').format('YYYY-MM-DD');
				this.date_end(month_end);

				this.page.updateData();
			}, 500);
		});

		this.date_end.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.end_date_timeout) 
				clearTimeout(this.end_date_timeout);

			// Set new timeout to wait for user to finish typing
			this.end_date_timeout = setTimeout(() => {
				let ed = moment(newValue, 'YYYY-MM-DD', true);
				if (!ed.isValid()) return;

				if (newValue.length === 10)
				{
					let sd = moment(this.date_start(), 'YYYY-MM-DD', true);
					if (sd.isValid() && ed.isBefore(sd))
					{
						Grape.alerts.alert({ type: 'error', title: tr('Invalid Date Range'), message: tr('End date cannot be before start date') });
						return;
					}
					this.page.updateData();
				}
			}, 1000);
		});

		this.selected_leave_types.subscribe(() => {
			this.page.updateData();
		});

		this.selected_options_text = ko.computed(() => {
			let selected_ids = this.selected_leave_types();
			if (selected_ids.length === 0) return 'View leave type options';

			if (selected_ids.length > 3) return `${selected_ids.length} leave types selected`;

			let selected_desc = this.leave_types().filter(option => selected_ids.includes(option.leave_type_id)).map(option => option.description);
			return selected_desc.join(', ');
		});
	}

	show_report_help()
	{
		Grape.dialog.open('EmployeesTakingLeavePerDepartmentCountHelp', {employee_id: this.page.bindings.id });
	}

	graph_option_click (row)
	{
		let selected_options = this.selected_leave_types();

		if (selected_options.indexOf(row.leave_type_id) == -1)
			this.selected_leave_types.push(row.leave_type_id);
		else
			this.selected_leave_types.remove(row.leave_type_id);

		this.refresh_button(true);
		return true;
	}
}

class ReportLeavePerDepartmentEmployeesPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportLeavePerDepartmentEmployeeViewModel(this);
		this.chart;
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeesPerDepartmentReport'))
			return;

		document.title = tr('Employees Taking Leave Per Department Count');
		window.current_page_title(tr('Employees Taking Leave Per Department Count'));

		let res = await Grape.fetches.getJSON('/api/record', { table: 'leave_type', limit: 100 });
		this.viewModel.leave_types(res.records);

		this.setupGraph();
		this.updateData();
	}

	async updateData()
	{
		if (this.viewModel.date_start() != '' &&
			this.viewModel.date_start() != undefined &&
			this.viewModel.date_end() != '' &&
			this.viewModel.date_end() != undefined
		)
		{
			let data = {
				date_start: this.viewModel.date_start(),
				date_end: this.viewModel.date_end(),
				leave_type_ids: this.viewModel.selected_leave_types()
			};

			this.viewModel.loader(true);
			let res = await Grape.fetches.postJSON('/report_graphs/leave_per_employees_department', data);
			
			if (res)
			{
				this.buildGraph(res);
				this.viewModel.loader(false);
				this.viewModel.refresh_button(false); // hide refresh button
			}
		}
	}

	setupGraph()
	{
		this.chart = c3.generate({
			size: {
				height: 400
			},
			data: {
				x: 'x',
				columns: [
					/* ['x', 'Platsoft', 'Skinchem', 'Maths', 'IG' , 'QC' , 'Platlife' , 'Platsoft', 'Skinchem', 'Maths', 'IG' , 'QC' , 'Platlife'],
					['Leave %', 30, 70, 100, 100, 100, 50, 30, 70, 100, 100, 100, 50] */
				],
				colors: {
					'Leave %': '#31859D'
				},
				type: 'bar',
				labels: {
					format: {
						// 'Leave %': d3.format('%')
						'Leave %': function (v, id, i, j) { return v + '%'; }
					}
				}
			},
			transition: {
				duration: 1000
			},
			legend: {
				show: false
			},
			bar: {
				width: {
					ratio: 0.7 // this makes bar width 50% of length between ticks
				}
			},
			axis: {
				x: {
					type: 'category' // this needed to load string x value
					/* label: {
						text: 'Departments',
						position: 'outer-center'
					} */
				}
			}
		});
	}

	buildGraph(res)
	{
		if (res != null)
		{
			// reset
			this.viewModel.total_leave_in_company(0);
			this.viewModel.department_with_most_leave('None');
			this.viewModel.department_leave_total(0);

			let labelArray = ['x'];
			let dataArray = ['Leave %'];
			let highest_percent = 0;

			let total_leave_combined = 0;
			for (let a = 0; a < res.length; a++)
				total_leave_combined += res[a].total_people_taking_leave;

			this.viewModel.total_leave_in_company(Math.round(total_leave_combined, 2));

			for (let a = 0; a < res.length; a++)
			{
				let percent = ((res[a].total_people_taking_leave / res[a].total_employees) * 100).toFixed(2);
				if (percent > 0)
				{
					labelArray.push(res[a].department);
					// dataArray.push(res[a].total);
					dataArray.push(percent);
				}

				// find highest
				if (Number(percent) > Number(highest_percent))
				{
					highest_percent = percent;
					this.viewModel.department_leave_total(res[a].total_people_taking_leave + ' out of ' + res[a].total_employees);
					this.viewModel.department_with_most_leave(res[a].department);
				}
			}

			this.chart.unload(); // clear chart

			setTimeout(() => {
				this.chart.load({
					columns: [
						labelArray,
						dataArray
					]
				});
			}, 1100);
		}
		else
		{
			this.chart.unload(); // clear chart
			this.viewModel.total_leave_in_company(0);
			this.viewModel.department_with_most_leave('None');
			this.viewModel.department_leave_total(0);
		}
	}
}

export default {
	route: '[/]report/report_leave_per_department_people',
	page_class: ReportLeavePerDepartmentEmployeesPage,
	template: template,
	template_filename: 'translation/report_leave_per_department_people'
};
